import React from 'react';
export function TechniquesSection() {
  return <section data-id="element-4314">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4315">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4316">
          High-Speed Machining Techniques
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-12" data-id="element-4317">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-4318">
          <div className="space-y-4" data-id="element-4319">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4320">
              Trochoidal Machining
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4321">
              Trochoidal milling is a method of machining used to create a slot
              wider than the cutting tool's cutting diameter. This is
              accomplished using a series of circular cuts known as a trochoidal
              tool path. A form of High Efficiency Milling (HEM), trochoidal
              milling leverages high speeds while maintaining a low radial depth
              of cut (RDOC) and a high axial depth of cut (ADOC). Trochoidal
              milling is largely based on the theory surrounding chip thinning
              in machining. Conventional thinking suggests that cutting tools
              have an optimal chip load that determines the ideal width and size
              of the chips produced. The concept of combating chip thinning
              involves machining with a chip load that is larger than "optimal"
              in order to maintain a constant maximum chip thickness. Plunge
              Roughing CNC plunge milling, also called z-axis milling, is a CNC
              milling process. In this process, the feed is provided linearly
              along the tool axis while doing CNC processing. Plunge milling is
              effective for the rough machining process of complex shape or free
              form shapes like impeller parts.
            </p>
          </div>
          <div data-id="element-4322">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/Trochoidal%20Milling.jpg" alt="Trochoidal Milling" className="w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4323" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center pt-8 border-t border-gray-100" data-id="element-4324">
          <div className="space-y-4 md:order-2" data-id="element-4325">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4326">
              Radial Chip Thinning
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4327">
              Radial chip thinning, which occurs whenever radial-cutter
              engagement falls below 50 percent of the cutter diameter, is just
              as relevant on CNC machining centers as it is on manually-operated
              knee mills. For example, a 1/2-inch, 4-flute end mill feeding at
              0.01-inch per tooth (IPT) with a 1/4-inch or greater stepover
              (radial depth of cut) produces a chip thickness equal to the
              programmed IPT feedrate, or 0.010-inch. But decrease the stepover
              to 10-percent (0.050-inch) and the IPT value must be bumped up to
              0.0167-inch to achieve comparable chip thickness.
            </p>
          </div>
          <div className="md:order-1" data-id="element-4328">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/Radial%20Chip%20Thinning.png800x800.png" alt="Radial Chip Thinning" className="w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4329" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 pt-8 border-t border-gray-100" data-id="element-4330">
          <div className="space-y-4" data-id="element-4331">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4332">Side Steps</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4333">
              Side steps are the connections that create effective transitions
              between adjacent tool paths when feed rates are particularly high.
              Parallel scan-line surface machining is the type of machining that
              has been used for the last ten years to finish machine
              multi-surface models. This type of machining tends to produce
              sharp stepover moves at the end of every pass. Using simple
              "looping" tool paths in place of sharper turns between scan passes
              is an appropriate solution at moderate feed rates (20-40 ipm).
              However, at higher feeds, these simple rounded moves are still too
              sharp. An alternative that has proven more effective in some cases
              is a "golf club" stepover between passes.
            </p>
          </div>
          <div className="space-y-4" data-id="element-4334">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4335">Cornering</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4336">
              To exactly execute a sharp corner in the toolpath, the feedrate of
              a CNC machine must instantaneously drop to zero at that point.
              This constraint is problematic in the context of high-speed
              machining, since it incurs very high deceleration/acceleration
              rates near sharp corners, which increase the total machining time,
              and may incur significant path deviations (contour errors) at
              these points. HSM Cornering Strategies utilize linear drives on
              all axes and high speed spindles in order to ensure high
              deceleration and acceleration in and out of corners.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 pt-8 border-t border-gray-100" data-id="element-4337">
          <div className="space-y-4" data-id="element-4338">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4339">Smart Machining</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4340">
              Feedrate optimization is an important aspect of getting shorter
              machining time and increase the potential of efficient machining.
              Autonomous machining system and optimization strategies predict
              and improve the performance of milling operations. The machining
              process is simulated and analyzed in virtual machining framework
              to extract cutter-workpiece engagement conditions. Cutting force
              along the cutting segmentation is evaluated based on the laws of
              mechanics of milling. In simulation, constraint-based optimization
              scheme is used to maximize the cutting force by calculating
              acceptable feedrate levels as the optimizing strategy. The
              intelligent algorithm was integrated into autonomous machining
              system to modify NC program to accommodate these new feedrates
              values.
            </p>
          </div>
          <div className="space-y-4" data-id="element-4341">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4342">
              Knowledge of Stock Remaining
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4343">
              Go from rough to semi finish machining without intermediate
              cutting when your programming software accurately recognizes
              remaining stock from previous operations.
            </p>
          </div>
        </div>
      </div>
    </section>;
}